"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateRangeFilter = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
const React = __importStar(require("react"));
const index_js_1 = require("../../../utils/index.js");
const FilterButtonBar_js_1 = require("../FilterButtonBar.js");
const BaseFilter_js_1 = require("../BaseFilter.js");
require("@itwin/itwinui-css/css/table.css");
const DatePickerInput_js_1 = __importDefault(require("./DatePickerInput.js"));
const defaultStrings = {
    from: 'From',
    to: 'To',
};
const defaultFormatDate = (date) => {
    const formatter = new Intl.DateTimeFormat('en-us', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
    });
    return formatter.format(date);
};
const defaultParseInput = (text) => {
    // Checks whether date is in correct format e.g. Feb 11, 2021
    if (/^[a-z]{3}\s\d{1,2},\s\d{4}$/gi.test(text)) {
        return new Date(text);
    }
    return new Date('');
};
const DateRangeFilter = (props) => {
    var _a, _b, _c, _d;
    const { column, translatedLabels, setFilter, clearFilter, formatDate = defaultFormatDate, parseInput = defaultParseInput, placeholder = 'MMM dd, yyyy', } = props;
    (0, index_js_1.useTheme)();
    const translatedStrings = { ...defaultStrings, ...translatedLabels };
    const [from, setFrom] = React.useState(((_a = column.filterValue) === null || _a === void 0 ? void 0 : _a[0]) ? new Date((_b = column.filterValue) === null || _b === void 0 ? void 0 : _b[0]) : undefined);
    const onFromChange = React.useCallback((date) => {
        setFrom((prevDate) => {
            if (prevDate || !date) {
                return date;
            }
            return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
        });
    }, []);
    const [to, setTo] = React.useState(((_c = column.filterValue) === null || _c === void 0 ? void 0 : _c[1]) ? new Date((_d = column.filterValue) === null || _d === void 0 ? void 0 : _d[1]) : undefined);
    const onToChange = React.useCallback((date) => {
        setTo((prevDate) => {
            if (prevDate || !date) {
                return date;
            }
            return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999);
        });
    }, []);
    const onKeyDown = (event) => {
        if (event.altKey) {
            return;
        }
        if (event.key === 'Enter') {
            setFilter([from, to]);
        }
    };
    return (React.createElement(BaseFilter_js_1.BaseFilter, null,
        React.createElement(DatePickerInput_js_1.default, { label: translatedStrings.from, date: from, onChange: onFromChange, formatDate: formatDate, parseInput: parseInput, onKeyDown: onKeyDown, placeholder: placeholder, selectedDate: to, isFromOrTo: 'from', setFocus: true }),
        React.createElement(DatePickerInput_js_1.default, { label: translatedStrings.to, date: to, onChange: onToChange, formatDate: formatDate, parseInput: parseInput, onKeyDown: onKeyDown, placeholder: placeholder, selectedDate: from, isFromOrTo: 'to' }),
        React.createElement(FilterButtonBar_js_1.FilterButtonBar, { setFilter: () => setFilter([from, to]), clearFilter: clearFilter, translatedLabels: translatedLabels })));
};
exports.DateRangeFilter = DateRangeFilter;
